import { Info } from "@material-ui/icons";
import { Box, Popover, Typography } from "@mui/material";
import React from "react";

export default function InfoPopper(props){



    const [anchorEl, setAnchorEl] = React.useState(null);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;

    const {
        bodyText = ''
    } = props;
    
    return (
        <>   
            <Info onClick={handleClick} sx={{cursor:'pointer', color:'#637381',
                    height:'16px'}} {...props}/>
            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                }}

            >
                <Box sx={{width:400, padding:2}}>
                    <Typography variant="Body1">
                        {bodyText}
                    </Typography>
                </Box>
            </Popover>
        </>
    );
    
}